import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { WordTitle } from "./WordTitle";
import { ScrubText } from "./ScrubText";
import { VeroButton } from "./VeroButton";
import { IMAGES } from "../../constants/images";

export const DiscoverSection = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [80, -80]);

  return (
    <section className="relative px-6 md:px-14 pt-28 md:pt-44 pb-16 md:pb-24" data-testid="discover-section">
      <div ref={ref} className="relative min-h-[85vh] md:min-h-screen">
        <div className="absolute left-0 top-0 z-10 font-serif text-3xl md:text-6xl leading-tight text-white">
          <WordTitle lines={t.discover.split1} />
        </div>
        <div className="flex justify-center items-center h-full pt-24 md:pt-0">
          <motion.img
            src={IMAGES.rider_silhouette}
            alt="Apex rider"
            style={{ y }}
            className="w-[70%] md:w-[38%] object-cover"
          />
        </div>
        <div className="absolute right-0 bottom-0 z-10 font-serif text-3xl md:text-6xl leading-tight text-white text-right">
          <WordTitle lines={t.discover.split2} />
        </div>
      </div>

      <div className="mt-28 md:mt-44 max-w-4xl mx-auto text-center">
        <ScrubText
          text={t.discover.statement}
          className="font-serif text-2xl md:text-4xl lg:text-[2.6rem] leading-snug text-white"
        />
        <ScrubText
          text={t.discover.body}
          className="mt-10 text-base md:text-lg text-zinc-300 font-light leading-relaxed max-w-2xl mx-auto"
        />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-14"
        >
          <VeroButton text={t.discover.cta} to="/book" testId="discover-reserve-btn" />
        </motion.div>
      </div>
    </section>
  );
};
